import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.ConstructionMaze;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "ConstructionMaze.Phaser.IntroductionScene.1",
            "ConstructionMaze.Phaser.IntroductionScene.2",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/ConstructionMazeGame/scenes/GameIntro.ts